import React from 'react';

/** Must match a `<symbol id="icon-${name}">` defined in IconSprite.tsx. */
export type IconName =
  | 'star'
  | 'eye'
  | 'bag5'
  | 'chevron-down'
  | 'alt-arrow-left'
  | 'alt-arrow-right'
  | 'add'
  | 'minus'
  | 'check'
  | 'x'
  | 'customer';

interface IconProps extends Omit<React.SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  size?: number | string;
}

/**
 * Renders one occurrence of a de-duplicated icon via `<use>` against IconSprite.tsx's symbols.
 * `size` sets both width and height; pass `width`/`height` separately to override either.
 */
const Icon = ({ name, size, width, height, ...rest }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width ?? size} height={height ?? size} {...rest}>
    <use href={`#icon-${name}`} />
  </svg>
);

export default Icon;
